import { useIntl } from 'react-intl'
import { MaybeString } from '../../utils'

export const useTranslationOrText = (
  translationId: MaybeString,
  text?: MaybeString
) => {
  const { formatMessage } = useIntl()

  return translationId ? formatMessage({ id: translationId }) : text || ''
}
